/*#__PURE__*/ export default JSON.parse('{"key":"eventVisualisation","type":"root","items":[{"key":"defaultSelectedTab","def":"scores","type":"string"}]}');